import React from "react";
import { styled } from "@mui/material";
import Tooltip from "@hyro-components/Tooltip";
import palette from "src/theme/palette";
import { EXPRESSION_DIALOG_STRINGS } from "src/components/collections/expression-dialog-v2/ExpressionDialogV2.consts";

const StyledTag = styled("span")({
  backgroundColor: palette.tertiary[300],
  padding: "0 6px",
  borderRadius: "6px",
  height: 18,
  display: "inline-flex",
  alignItems: "center",
  fontSize: 12,
  letterSpacing: "0.4px",
  color: palette.primary[500],
  whiteSpace: "nowrap"
});

const ExpressionTag = ({ tooltip = EXPRESSION_DIALOG_STRINGS.EXPRESSION_TAG_TOOLTIP }) => (
  <Tooltip
    disableInteractive
    title={tooltip}
    component="span"
    stackStyle={{ display: "inline-flex" }}
  >
    <StyledTag data-testid="custom-expression-tag">
      Custom expression
    </StyledTag>
  </Tooltip>
);

export default ExpressionTag;
